'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Application error:', error);
    
    // Check if it's a chunk loading error
    if (
      error.message && 
      (error.message.includes('Loading chunk') || 
       error.message.includes('failed') ||
       error.message.includes('ChunkLoadError'))
    ) {
      // Force a reload after a short delay
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4 text-center">
      <div className="max-w-md rounded-lg border bg-card p-8 shadow-md">
        <h2 className="mb-4 text-2xl font-bold">Something went wrong</h2>
        <p className="mb-6 text-muted-foreground">
          {error.message || 'An unexpected error occurred in the application.'}
        </p>
        
        {error.message && error.message.includes('chunk') ? (
          <p className="mb-4 text-sm text-amber-600">
            Loading resources failed. Automatic reload in progress...
          </p>
        ) : null}
        
        <div className="flex flex-col space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0">
          <Button
            onClick={() => reset()}
            className="w-full sm:w-auto"
          >
            Try again
          </Button>
          <Button
            variant="outline"
            className="w-full sm:w-auto"
            asChild
          >
            <Link href="/">Return to home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
} 